export default "__VITE_ASSET__76634d9c__"